/**
 * tdesign v1.0.3
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _slicedToArray } from '../_chunks/dep-e43cf21c.js';
import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import { i as isFunction_1 } from '../_chunks/dep-f10515e8.js';
import { I as ImageModal } from '../_chunks/dep-10388ab5.js';
import { imageViewerDefaultProps } from './defaultProps.js';
import useImageScale from './hooks/useImageScale.js';
import useList from './hooks/useList.js';
import useViewerScale from './hooks/useViewerScale.js';
import useControlled from '../hooks/useControlled.js';
import '../_chunks/dep-2acfafca.js';
import '../_chunks/dep-c3f1141e.js';
import '../_chunks/dep-4941ebe7.js';
import '../_chunks/dep-e9b62d1f.js';
import '../_chunks/dep-88cd50bf.js';
import '../_chunks/dep-92728dc5.js';
import '../_chunks/dep-46de7b2e.js';
import '../_chunks/dep-77e34309.js';
import 'tdesign-icons-react';
import 'classnames';
import '../tooltip/index.js';
import '../tooltip/Tooltip.js';
import '../popup/index.js';
import '../popup/Popup.js';
import 'react-transition-group';
import 'react-popper';
import '../_util/useAnimation.js';
import '../hooks/useConfig.js';
import '../config-provider/ConfigContext.js';
import '../_chunks/dep-d71ee5f3.js';
import '../_chunks/dep-4b8f240e.js';
import '../_chunks/dep-9acbc163.js';
import '../_chunks/dep-7b52f080.js';
import '../_chunks/dep-dcb5aa2a.js';
import '../_chunks/dep-ee4bf8c2.js';
import '../_chunks/dep-934eda0c.js';
import '../_chunks/dep-7dce2c26.js';
import '../_chunks/dep-12510d64.js';
import '../_chunks/dep-6b568d83.js';
import '../_chunks/dep-304e657b.js';
import '../_chunks/dep-6506fbc2.js';
import '../_chunks/dep-bb5d7b1e.js';
import '../_chunks/dep-e285f2f8.js';
import '../_chunks/dep-f4a320cd.js';
import '../_chunks/dep-ec70b95c.js';
import '../locale/zh_CN.js';
import '../_common/js/global-config/locale/zh_CN.js';
import 'dayjs';
import '../_chunks/dep-cbcc9f89.js';
import '../_common/js/global-config/default-config.js';
import '../hooks/usePrevious.js';
import '../common/Portal.js';
import '../_util/dom.js';
import 'raf';
import '../_chunks/dep-6c5254c6.js';
import '../_util/easing.js';
import '../popup/hooks/useTrigger.js';
import 'react-is';
import '../popup/utils/ref.js';
import '../_util/composeRefs.js';
import '../popup/utils/transition.js';
import '../_util/useMutationObserver.js';
import '../_chunks/dep-01ce608f.js';
import '../_chunks/dep-77a54538.js';
import '../_chunks/dep-c1f93350.js';
import '../_util/useWindowSize.js';
import '../popup/defaultProps.js';
import '../_chunks/dep-f721d103.js';
import '../_chunks/dep-4559db64.js';
import '../_chunks/dep-c00532d4.js';
import '../_chunks/dep-33ffecad.js';
import '../_util/noop.js';
import '../popup/style/css.js';
import '../popup/type.js';
import '../tooltip/defaultProps.js';
import '../tooltip/TooltipLite.js';
import '../_util/useSwitch.js';
import '../_util/usePersistFn.js';
import '../_common/js/utils/getPosition.js';
import '../tooltip/style/css.js';
import '../tooltip/type.js';
import '../locale/LocalReceiver.js';
import '../config-provider/index.js';
import '../config-provider/ConfigProvider.js';
import './utils.js';
import '../dialog/index.js';
import '../dialog/Dialog.js';
import '../_util/useSetState.js';
import '../dialog/defaultProps.js';
import '../dialog/DialogCard.js';
import '../button/index.js';
import '../button/Button.js';
import '../hooks/useDomRefCallback.js';
import '../_util/useRipple.js';
import '../_util/setStyle.js';
import '../loading/index.js';
import '../loading/Loading.js';
import '../loading/gradient.js';
import '../_common/js/loading/circle-adapter.js';
import '../_common/js/utils/set-style.js';
import '../_common/js/utils/helper.js';
import '../_chunks/dep-fd3498b6.js';
import '../_chunks/dep-ec16db36.js';
import '../_chunks/dep-036ad2cc.js';
import '../_chunks/dep-0e15088f.js';
import '../loading/defaultProps.js';
import '../loading/plugin.js';
import '../_util/react-render.js';
import '../_chunks/dep-e0370ebe.js';
import '../loading/style/css.js';
import '../loading/type.js';
import '../button/defaultProps.js';
import '../_util/parseTNode.js';
import '../button/style/css.js';
import '../button/type.js';
import '../hooks/useGlobalIcon.js';
import '../dialog/hooks/useDialogEsc.js';
import '../dialog/hooks/useLockStyle.js';
import '../_util/useLayoutEffect.js';
import '../_common/js/utils/getScrollbarWidth.js';
import '../dialog/hooks/useDialogPosition.js';
import '../dialog/hooks/useDialogDrag.js';
import '../dialog/utils.js';
import '../_common/js/log/index.js';
import '../_common/js/log/log.js';
import '../dialog/plugin.js';
import '../dialog/style/css.js';
import '../dialog/type.js';
import './hooks/useMirror.js';
import './hooks/usePosition.js';
import './hooks/useIndex.js';
import './hooks/useRotate.js';
import './hooks/useScale.js';
import './hooks/useIconMap.js';

var ImageViewer = function ImageViewer(props) {
  var mode = props.mode,
    trigger = props.trigger,
    images = props.images,
    title = props.title,
    imageScaleD = props.imageScale,
    viewerScaleD = props.viewerScale;
  var _useControlled = useControlled(props, "visible", function (visible2, context) {
      isFunction_1(props.onClose) && props.onClose(context);
    }),
    _useControlled2 = _slicedToArray(_useControlled, 2),
    visible = _useControlled2[0],
    setVisible = _useControlled2[1];
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    visibled = _useState2[0],
    setVisibled = _useState2[1];
  var list = useList(images);
  var imageScale = useImageScale(imageScaleD);
  var viewerScale = useViewerScale(viewerScaleD);
  var isMini = mode === "modeless";
  var close = function close(context) {
    setVisible(false, context);
    setTimeout(function () {
      return setVisibled(false);
    }, 196);
  };
  var open = function open() {
    if (!images) return;
    setVisible(true, null);
    setVisibled(true);
  };
  var uiImage = isFunction_1(trigger) ? trigger({
    open: open,
    close: close,
    onOpen: open,
    onClose: close
  }) : trigger;
  return /* @__PURE__ */React.createElement(React.Fragment, null, uiImage, visibled && /*#__PURE__*/createPortal( /* @__PURE__ */React.createElement(ImageModal, {
    title: title,
    visible: visible,
    images: list,
    isMini: isMini,
    imageScale: imageScale,
    viewerScale: viewerScale,
    zIndex: props.zIndex,
    defaultIndex: props.defaultIndex,
    index: props.index,
    onIndexChange: props.onIndexChange,
    draggable: props.draggable,
    closeOnOverlay: props.closeOnOverlay,
    closeBtn: props.closeBtn,
    showOverlay: props.showOverlay,
    onClose: close,
    onOpen: open
  }), document.body));
};
ImageViewer.displayName = "ImageViewer";
ImageViewer.defaultProps = imageViewerDefaultProps;

export { ImageViewer as default };
//# sourceMappingURL=ImageViewer.js.map
